import * as actionTypes from './actionTypes'
import { fromJS } from 'immutable'


export const setMainTabbarData = (data) => ({
    type:actionTypes.SET_MAIN_TABBAR_DATA,
    data
})